import { Redirect, Route, useLocation } from 'react-router-dom';
import { getJwtToken, validateJWT } from '@utils/jwt';

const SubRouter: React.FC<SubRouterProps> = ({ path, children, auth = false, exact = false }) => {
    const location = useLocation();

    if (auth) {
        const token = getJwtToken();

        const isValidToken = token ? validateJWT(token) : false;

        if (!isValidToken) {
            return <Redirect to="/auth/login" from={location.pathname} />;
        }
    }
    return (
        <Route exact={exact} path={path}>
            {children}
        </Route>
    );
};

interface SubRouterProps {
    path: string;
    auth?: boolean;
    exact?: boolean;
}

export default SubRouter;
